import React, { type FC } from 'react'
import type { ProductInfoProduct } from '../../../types'
import { ProductGrid } from '../productGrid'
import { useMoreLikeThisProductSelect } from '../hooks/useMoreLikeThisProductSelect'

type Props = {
  products: ProductInfoProduct[]
  listName: string
  listPosition: string
}

export const MoreLikeThisTabPanel: FC<Props> = ({
  products,
  listName,
  listPosition,
}) => {
  const handleProductClick = useMoreLikeThisProductSelect({
    products,
    listName,
    component: 'tabbed',
    listPosition,
  })

  return <ProductGrid products={products} onProductClick={handleProductClick} />
}
